<template>
    <div class="create">
        <el-dialog :title="editId == 0 ? '添加' : '编辑'" :visible.sync="dialogVisible" width="650px" :before-close="handleClose">
            <div class="main">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="right" class="demo-ruleForm" v-loading="formload">
                    <el-form-item label="产品名称：" prop="name">
                        <el-input v-model="ruleForm.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="销售价：" prop="sale_price">
                        <el-input v-model="ruleForm.sale_price" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="价格上限：" prop="price_top">
                        <el-input v-model="ruleForm.price_top" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="价格下限：" prop="price_bottom">
                        <el-input v-model="ruleForm.price_bottom" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="URL地址：" prop="product_url">
                        <el-input v-model="ruleForm.product_url" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="medium">取 消</el-button>
                <el-button @click="submit" type="primary" size="medium" :loading="load">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            formload: false,
            load: false,
            dialogVisible: false,
            ruleForm: {
                name: "",
                sale_price: "",
                price_top: "",
                price_bottom: "",
                product_url: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入产品名称",
                        trigger: "blur",
                    },
                ],
                sale_price: [
                    {
                        required: true,
                        message: "请输入销售价",
                        trigger: "blur",
                    },
                ],
                price_top: [
                    {
                        required: true,
                        message: "请输入价格上限",
                        trigger: "blur",
                    },
                ],
                price_bottom: [
                    {
                        required: true,
                        message: "请输入价格下限",
                        trigger: "blur",
                    },
                ],
                product_url: [
                    {
                        required: true,
                        message: "请输入URL地址",
                        trigger: "blur",
                    },
                ],
            },
            editId: 0,
        };
    },
    created() {},
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        getAddress() {},
        ...mapActions({
            createQuick: "brand/createQuick",
            editQuick: "brand/editQuick",
        }),
        getDetail(row) {
            this.ruleForm = JSON.parse(JSON.stringify(row));
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.load = true;
                    let { name, sale_price, price_top, price_bottom, product_url } = this.ruleForm;
                    let opt = {
                        id: this.editId == 0 ? null : this.editId,
                        token: this.getToken,
                        name,
                        sale_price,
                        price_top,
                        price_bottom,
                        product_url,
                    };
                    let url;
                    if (this.editId == 0) {
                        url = this.createQuick;
                    } else {
                        url = this.editQuick;
                    }
                    url(opt).then(({ data }) => {
                        this.load = false;
                        if (data.code == 1) {
                            this.$message.success(`${this.editId == 0 ? "添加成功！" : "修改成功！"}`);
                            this.$emit("init");
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        handleClose() {
            this.load = false;
            this.formload = false;
            this.editId = 0;
            this.ruleForm = {
                name: "",
                sale_price: "",
                price_top: "",
                price_bottom: "",
                product_url: "",
            };
            this.$refs.ruleForm.resetFields();
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    .demo-ruleForm {
        max-height: 420px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        h3 {
            margin-bottom: 20px;
            padding: 10px 0;
        }
        ::v-deep .el-form-item {
            width: 500px;
        }
    }
    .tag-group {
        padding-top: 10px;
        .el-tag {
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            height: 34px !important;
            line-height: 34px !important;
            font-size: 14px;
        }
    }
    .el-date-editor .el-range-separator {
        width: auto !important;
    }
    .upload-demo {
        position: relative;
        .down {
            position: absolute;
            right: 180px;
            top: 0;
            .el-link {
                font-size: 12px;
                line-height: 20px;
            }
        }
    }
}
</style>